import React, { useState } from "react";
import { Input, Button, Upload, Form, message as antdMessage } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import styles from "./SupportNewMessage.module.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import MenuTitle from "../../../Components/MenuTitlle/MenuTitle";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { postSupportMessage } from "../../../Api/DeliveryBarest";

// Helper function to convert a file to Base64
const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const SupportNewMessage = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const history = useHistory();
  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const onFinish = async (values) => {
    try {
      const fileBase64 =
        fileList.length > 0 ? await getBase64(fileList[0].originFileObj) : null;

      // Prepare the data
      const jsonData = {
        support_id: "0",
        department: "0",
        reply_to: "0",
        order_id: values.order_id,
        title: values.title,
        message: values.message,
        files: fileBase64 ? [fileBase64] : [],
      };
      postSupportMessage(jsonData,(succ,res)=>{
        if(succ){
            if(res.status===1){
                succToast('پیام شما با موفقیت ثبت شد')
                setFileList([]);
                setTimeout(() => {
                    history.push(`/${res.support_id}`)
                }, 1000);
            }else{
                errorToast(res.message)
            }
        }else{
            console.error(res)
        }
      })
    } catch (error) {
      console.error("Error generating Base64 or JSON:", error);
    }
  };

  return (
    <section style={{ width: "100vw", height: "100vh" }}>
      <div className={styles.formContainer}>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className={styles.formHolder}
        >
          <Form.Item
            name="order_id"
            label="شماره سفارش"
            rules={[
              { required: false, message: "لطفا شماره آیدی را وارد کنید!" },
            ]}
          >
            <Input placeholder="شماره آیدی را وارد کنید" />
          </Form.Item>

          <Form.Item
            name="title"
            label="عنوان"
            rules={[{ required: true, message: "لطفا عنوان را وارد کنید" }]}
          >
            <Input placeholder="عنوان پیغام..." />
          </Form.Item>

          <Form.Item
            name="message"
            label="پیام"
            rules={[{ required: true, message: "پیام خود را وارد کنید" }]}
          >
            <Input.TextArea rows={4} placeholder="متن پیام شما..." />
          </Form.Item>

          <Form.Item label="آپلود فایل">
            <Upload
              beforeUpload={() => false} // Prevent auto-upload
              fileList={fileList}
              onChange={handleFileChange}
              accept=".png,.jpg,.jpeg,.pdf,.docx,.zip"
            >
              <Button icon={<UploadOutlined />}>آپلود فایل</Button>
            </Upload>
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              background: "rgb(187, 0, 134)",
              border: "none",
              width: "100%",
              fontFamily: "iran-sans-num",
              margin:'1rem 0'
            }}
          >
            شروع چت
          </Button>
          <Button
            type="primary"
            htmlType="button"
            style={{
              border: "1px solid rgb(187, 0, 134)",
              color: "rgb(187, 0, 134)",
              background: "rgb(255, 255, 255)",
              width: "100%",
              fontFamily: "iran-sans-num",
            }}
            onClick={()=>history.goBack()}
          >
            بازگشت
          </Button>
        </Form>
      </div>
    </section>
  );
};

export default SupportNewMessage;
